import Box from "@/common/components/Box";
import { maintenanceForwardingsDirectiveEntryKlasses } from "@/features/maintenance/features/workflows/constants/forwardings/maintenanceForwardingsDirectiveEntryKlasses.constant";
import { maintenanceForwardingsDirectiveEntryStateStatus } from "@/features/maintenance/features/workflows/constants/forwardings/steps/directiveEntry/maintenanceForwardingsDirectiveEntryStateStatus.constant";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingDirectiveEntryStatus } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { useMemo } from "react";
import DirectiveEntryExecutionEntryPending from "./content/ExecutionEntryPending";

const MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry = () => {
  const { forwarding, forwardingUpdatedAt, directiveEntryKlass } = useForwardingTabContext<
    MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry
  >();

  const DirectiveEntryStatusComponent = useMemo(() => {
    const directiveEntryStatusData = maintenanceForwardingsDirectiveEntryStateStatus[MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry]?.status[forwarding.status];

    if (!directiveEntryStatusData) {
      return false;
    }

    return directiveEntryStatusData.component || false;
  }, [forwardingUpdatedAt, directiveEntryKlass]);

  const isDiagnosticEntryCompleted = useMemo(() => {
    return ![
      MaintenanceForwardingDirectiveEntryStatus.Pending,
      MaintenanceForwardingDirectiveEntryStatus.AwaitingManualStart,
      MaintenanceForwardingDirectiveEntryStatus.InProgress,
    ].includes(forwarding.directive_entry.status) || (
        forwarding.directive_entry.status === MaintenanceForwardingDirectiveEntryStatus.InProgress &&
        forwarding.directive_entry?.last_review?.state === 'disapproved'
      );
  }, [forwardingUpdatedAt]);

  return (
    <Box className="p-4 flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-lg font-semibold">
            {maintenanceForwardingsDirectiveEntryKlasses[forwarding.directive_entry_type]?.label}
          </p>
        </div>

        <div>
          {DirectiveEntryStatusComponent && (
            <DirectiveEntryStatusComponent />
          )}
        </div>
      </div>

      {!isDiagnosticEntryCompleted && (
        <DirectiveEntryExecutionEntryPending />
      )}
    </Box>
  );
}

export default MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry;
